export const EMPTY_DATE_PLACEHOLDER = '—';

// Shared by maxLookbackStartDate() and isDateRangeOverMaxLookback() — both
// default to this value and must agree exactly, since the first produces the
// widest dateFrom the export can use and the second validates that same range.
export const MAX_LOOKBACK_DAYS = 180;
